export const siigsolLegends = {
  "Projet_MOS_Essai:SIIGSOL_Argile_MRC_MOS": {
    title: "Pourcentage d'Argile",
    items: [
      { color: "#d77f3f", label: "Très faible: ≤ 6,65 %" },
      { color: "#c09750", label: "Faible: > 6,65 → ≤ 14,84 %" },
      { color: "#d1cc76", label: "Modéré: > 14,84 → ≤ 23,03 %" },
      { color: "#6ca363", label: "Élevé: > 23,03 → ≤ 31,23 %" },
      { color: "#37744b", label: "Très élevé: > 31,23 → ≤ 39,42 %" },
      { color: "#223b27", label: "Sévère: > 39,42 → ≤ 47,61 %" },
      { color: "#050603", label: "Extrême: > 47,61 → ≤ 55,80 %" }
    ]
  },
  "Projet_MOS_Essai:SIIGSOL_CEC_MRC_MOS": {
    title: "Quantité CEC cmolc/kg",
    items: [
      { color: "#d77f3f", label: "Très faible: ≤ 2,512" },
      { color: "#c09750", label: "Faible: > 2,512-≤ 3,961" },
      { color: "#d1cc76", label: "Modéré: > 3,961- ≤ 5,410" },
      { color: "#6ca363", label: "Élevé: > 5,410- ≤ 6,859" },
      { color: "#37744b", label: "Très élevé: > 6,859- ≤ 8,308" },
      { color: "#223b27", label: "Sévère: > 8,308- ≤ 9,757" },
      { color: "#050603", label: "Extrême: > 9,757- et ≥ 11,206" }
    ]
  },
  "Projet_MOS_Essai:SIIGSOL_COrg_MRC_MOS": {
    title: "Pourcentage COrg",
    items: [
      { color: "#00bfbf", label: "Très faible: ≤ 1,75 %" },
      { color: "#00f51f", label: "Faible: > 1,75 → ≤ 7,03 %" },
      { color: "#aaff00", label: "Modéré: > 7,03 → ≤ 7,84 %" },
      { color: "#ffbf00", label: "Élevé: > 7,84 → ≤ 8,56 %" },
      { color: "#ea7f15", label: "Très élevé: > 8,56 → ≤ 9,31 %" },
      { color: "#a36d38", label: "Sévère: > 9,31 → ≤ 10,34 %" },
      { color: "#141414", label: "Extrême: > 10,34 → ≤ 14,91 %" }
    ]
  },
  "Projet_MOS_Essai:SIIGSOL_Limon_MRC_MOS": {
    title: "Pourcentage de Limon",
    items: [
      { color: "#4aad5a", label: "Très faible: ≤ 7,82 %" },
      { color: "#74c353", label: "Faible: > 7,82 → ≤ 19,73 %" },
      { color: "#b5d663", label: "Modéré: > 19,73 → ≤ 21,61 %" },
      { color: "#ffe710", label: "Élevé: > 21,61 → ≤ 23,19 %" },
      { color: "#ffce08", label: "Très élevé: > 23,19 → ≤ 25,61 %" },
      { color: "#ff9c08", label: "Sévère: > 25,61 → ≤ 28,77 %" },
      { color: "#ff7b10", label: "Extrême: > 28,77 → ≤ 45,24 %" }
    ]
  },
  "Projet_MOS_Essai:SIIGSOL_pH_MRC_MOS": {
    title: "Quantité de pH",
    items: [
      { color: "#0571b0", label: "Très faible: ≤ 3,73" },
      { color: "#4496c4", label: "Faible: > 3,73 → ≤ 3,98" },
      { color: "#ebf1f4", label: "Modéré: > 3,98 → ≤ 4,78" },
      { color: "#f6e6de", label: "Élevé: > 4,78 → ≤ 4,96" },
      { color: "#f5b396", label: "Très élevé: > 4,96 → ≤ 5,30" },
      { color: "#ee8e74", label: "Sévère: > 5,30 → ≤ 5,48" },
      { color: "#ca0020", label: "Extrême: > 5,48 → ≤ 5,96" }
    ]
  },
  "Projet_MOS_Essai:SIIGSOL_Sable_MRC_MOS": {
    title: "Pourcentage de Sable",
    items: [
      { color: "#2b83ba", label: "Très faible: ≤ 6,50 %" },
      { color: "#80bfac", label: "Faible: > 6,50 → ≤ 39,19 %" },
      { color: "#c7e9ad", label: "Modéré: > 39,19 → ≤ 60,40 %" },
      { color: "#ffffbf", label: "Élevé: > 60,40 → ≤ 65,00 %" },
      { color: "#fec980", label: "Très élevé: > 65,00 → ≤ 69,30 %" },
      { color: "#f17c4a", label: "Sévère: > 69,30 → ≤ 72,55 %" },
      { color: "#d7191c", label: "Extrême: > 72,55 → ≤ 88,11 %" }
    ]
  }
};